const { updateSyncErrors } = require('redux-form/lib/actions').default;

export const updateErrors = (dispatch, formName, errors) => {
  dispatch(updateSyncErrors(formName, errors));
};
